
export { useAddressBook } from "/opt/atlassian/pipelines/agent/build/packages/modules/module-customer/src/modules/addresses/hooks/index.ts"